module.exports = __webpack_public_path__ + "static/23-julia-6c137f3a0adaee3baec436444ac5b104.jpg";